<template>
  <fieldset>
    <h2>Combien de salles de bain faut-il équiper ?</h2>
    <div class="form-group">
      <div class="input-group">
        <label for="quantity">Nombre de salles de bain</label>
        <select name="quantity" id="quantity" autofocus v-model="quote.electricity.rooms.bathroom.quantity">
          <option :value="0">0</option>
          <option :value="1">1</option>
          <option :value="2">2</option>
        </select>
      </div>
      <button class="btn btn-action btn-secondary" @click.prevent="validateStep4">
        Valider
      </button>
    </div>
   
  </fieldset>
</template>

<script>



export default {

  props: ['currentStep'],

  computed: {
    quote() {
      return this.$store.state.quote;
    }
  },
  methods: {
    validateStep4() {
      if(this.quote.validStep < this.currentStep) {
        this.quote.validStep = 4; 
      }
      this.$emit('next-step');
    }
  }
}
</script>

<style>

</style>